/* eslint-disable max-len */
export const common = {
  'pd-processing-policy-file-name': 'pd_processing_policy_am.pdf',
  'user-agreement-sm-podbor-file-name-ru': 'user_agreement_sm_podbor_hy_ru.pdf',
  'user-agreement-sm-podbor-file-name': 'user_agreement_sm_podbor_hy.pdf',
  'accept-agreement-to-continue': 'Շարունակելու համար անհրաժեշտ է հաստատել տվյալների մշակման համաձայնությունը',
  'i-accept-user-data-proccesing': 'Ես տալիս եմ իմ անձնական տվյալների մշակման համաձայնություն',
  yes: 'Այո',
  no: 'Ոչ',
  continue: 'Շարունակել',
  start: 'Սկսել',
  skip: 'Շարունակել',
  delete: 'Հեռացնել',
  cancel: 'Չեղարկում',
  registration: 'Գրանցում',
  russia: 'Ռուսաստան',
  ukraine: 'Ուկրաինա',
  belarus: 'Բելառուս',
  'cookie-agreement': 'Մենք օգտագործում ենք cookie ֆայլեր՝ առաջարկությունները Ձեր կարիքներին համապատասխանեցնելու և կայքի հետ փոխգործակցելիս առավելագույն հարմարավետություն ապահովելու համար։ Շարունակելով օգտագործել կայքը՝ Դուք համաձայնում եք cookie ֆայլերի օգտագործմանը։',
  'accept-and-close': 'Ընդունել և փակել',
  'action-confirmation': 'Գործողության հաստատում',
  'execute-action': 'Կատարե՞լ գործողությունը։',
  ok: 'Լավ',
  'choose-date': 'Ընտրեք ամսաթիվը',
  'birth-date': 'Ծննդյան ամսաթիվ',
  'add-resume': 'Ավելացնել ինքնակենսագրություն',
  'invalid-file-type': 'Ֆայլի անթույլատրելի տեսակ',
  'cannot-load-stores': 'Չհաջողվեց բեռնել խանութի տվյալները։ Դիմեք ադմինիստրատորներին։',
  'nothing-found': 'Ոչինչ չի գտնվել',
  'store-business-card': 'Խանութի այցեքարտ',
  'date-time-creation': 'Ստեղծելու ամսաթիվ/ժամանակ',
  vacancy: 'Թափուր աշխատատեղեր',
  store: 'Խանութ',
  'file-upload-error': 'Ֆայլի բեռնման սխալ։ Կրկին փորձեք',
  'file-remove-error': 'Ֆայլի հեռացման սխալ։ Կրկին փորձեք',
  'file-upload-success': 'Ֆայլը հաջողությամբ բեռնվել է',
  'file-remove-success': 'Ֆայլը հաջողությամբ հեռացվել է',
  'file-already-uploaded': 'Դուք արդեն բեռնել եք այս ֆայլը',
};
